import { StyleSheet } from "@react-pdf/renderer";

const styles = StyleSheet.create({
    header: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      marginBottom: 20,
    },
    logoAndDetails: {
      flexDirection: 'column',
      justifyContent: 'flex-start',
    },
    invoiceTitle: {
      fontSize: 20,
      fontWeight: 600,
      textAlign: 'right',
      marginBottom: 5,
    },
    billingInfo: {
      flexDirection: 'column',
      alignItems: 'flex-end',
    },
    billingDetail: {
      fontSize: 12,
      color: '#000',
      textAlign: 'left',
      marginBottom: 3,
    },
    page: {
      flexDirection: 'column',
      padding: 20,
    },
    section: {
      margin: 10,
      padding: 10,
      flexGrow: 1,
    },
    title: {
      fontSize: 24,
      textAlign: 'center',
      marginBottom: 2,
    },
    subTitle: {
      color: '#FFA500',
      marginBottom: 5,
      fontSize: 13,
    },
    subTitleNC: {
      color: '#000',
      marginBottom: 5,
      fontSize: 13,
    },
    customUnderline: {
      width: '100%',
      height: 1,
      backgroundColor: '#FFA500',
      marginBottom: 10,
    },
    text: {
      fontSize: 12,
      marginBottom: 5,
    },
    warrantyText: {
      fontSize: 12,
      marginBottom: 20,
    },
    logoDocument: {
      width: 130,
      height: 100,
    },
    billingContainer: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      marginBottom: 20,
    },
    billingColumn: {
      flexDirection: 'column',
      justifyContent: 'flex-start',
    },
    productSection: {
      marginBottom: 10,
    },
    productItem: {
      flexDirection: 'row',
      justifyContent: 'space-between',
    },
    productDescription: {
      fontSize: 12,
      width: '70%',
    },
    productPrice: {
      fontSize: 12,
      width: '30%',
      textAlign: 'right',
    },
    footer: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      borderTopWidth: 1,
      borderTopColor: '#ccc',
      borderTopStyle: 'solid',
      color: '#000',
      marginTop: 10,
      marginBottom: 10,
    },
    copyrightText: {
      textAlign: 'left',
      fontSize: 10,
    },
    pageText: {
      textAlign: 'right',
      fontSize: 10,
      paddingTop: 10,
    },
  

    table: {
      flexDirection: 'column',
      marginTop: 20,
      marginBottom: 20,
      paddingTop: 10,
      paddingBottom: 10,
    },
    tableHeader: {
      backgroundColor: '#FFF8DC',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      paddingTop: 10,
      paddingBottom: 10,
      paddingLeft: 20,
      paddingRight: 20,
    },
    tableRow: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      borderBottomWidth: 1,
      borderBottomColor: '#EEEEEE',
      borderBottomStyle: 'solid',
      paddingTop: 10,
      paddingBottom: 10,
      paddingLeft: 20,
      paddingRight: 20,
    },
    tableFooter: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      paddingTop: 10,
      paddingBottom: 10,
      paddingLeft: 20,
      paddingRight: 20,
      borderTopWidth: 2,
      borderTopColor: '#000000',
      borderTopStyle: 'solid',
    },
    tableFooterText: {
      fontSize: 12,
      fontWeight: 'bold',
    },
    tableText: {
      fontSize: 12,
    },
  });
  export default styles;
  